/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    string, object, func,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

// import components
import DeliveryImageModal from '../../../common/DeliveryImageModal';
import DeliveryImagePreview from '../../../common/Image';

// import assets
import fallbackImgURL from '../../../assets/svg/FallbackImage';
import { ZoomInIconUrl } from '../../../assets/svg/ZoomInIcon';

// helpers
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = () => ({
    popupBtn: {
        fontSize: '14px',
        width: '100%',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        minWidth: '50px !important',
        marginRight: '0 !important',
        padding: '0 !important',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    deliveryPhotoBtn: {
        color: '#4A90E2',
        fontSize: '14px !important',
        textTransform: 'capitalize',
        textDecoration: 'underline',
        marginBottom: '0 !important',
        fontWeight: 'normal',
    },
    deliveryDetail: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    containerPadding: {
        paddingBottom: '2vh',
    },
    deliveryNote: {
        color: '#666666',
    },
    imgPreviewContainer: {
        maxHeight: '182px',
        position: 'relative',
    },
    zoomInIcon: {
        position: 'absolute',
        zIndex: '999',
        cursor: 'pointer',
        right: '0px',
    },
});

const DesktopDeliveryImage = ({
    classes, deliveryImageLink, ROSSOrderDeliveryDate, ROSSOrderDeliveryTimeFormat,
    orderNumber, brand, productName, productSku, deliveryImageFlags, recipientProfile, trackingNumber,
}) => {
    const dispatch = useDispatch();
    const [modalState, setModalState] = useState(false);
    const [isDeliveryImagePreviewEnabled, isDeliveryImageThumbsEnabled] = [deliveryImageFlags.preview, deliveryImageFlags.thumbs];

    const toggleModal = () => {
        if (!modalState) {
            dispatch(trackEvent({
                eventCategory: 'Order Details',
                eventAction: 'View Delivery Image',
                eventLabel: `${brand}|${orderNumber}|${productName}|${productSku}`,
            }));
        }
        setModalState(!modalState);
    };

    useEffect(() => {
         dispatch(trackEvent({
            eventCategory: 'Delivery Image',
            eventAction: 'Desktop: Customer is shown delivery image',
            eventLabel: `${brand}|${orderNumber}|${productName}|${productSku}`,
        }));
    }, []);

    const deliveryNoteIcon = 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt05e9ce4ba299cfa8/613f8f4afbe3b827300600dc/deliverynoteicon.svg';

    return (
        <>
            <Grid container xs={12} className={classes.containerPadding}>
                <Grid container item xs={4} className="bold">
                    <Grid className="margin-right-10">
                        <img src={deliveryNoteIcon} alt="notepad icon" />
                    </Grid>
                    <p className={classes.deliveryNote}>Delivery Note</p>
                </Grid>
                {ROSSOrderDeliveryDate && ROSSOrderDeliveryTimeFormat && <Grid item xs={4}>{ROSSOrderDeliveryDate} {ROSSOrderDeliveryTimeFormat}</Grid>}
                <Grid container className={classes.deliveryDetail} item xs={4}>
                    {
                        isDeliveryImagePreviewEnabled ? (
                            <Grid item className={classes.imgPreviewContainer}>
                                {
                                    <>
                                        <img 
                                            src={ZoomInIconUrl}
                                            className={classes.zoomInIcon}
                                            alt="zoom in icon"
                                            onClick={() => toggleModal()}
                                        />
                                        <DeliveryImagePreview
                                            alt={fallbackImgURL}
                                            src={deliveryImageLink}
                                            width="100%"
                                            height="100%"
                                        />
                                    </>
                                }
                            </Grid>
                        ) : null
                    }
                </Grid>
            </Grid>
            <DeliveryImageModal
                openModal={modalState}
                closeModal={toggleModal}
                deliveryImageLink={deliveryImageLink}
                isDeliveryImageThumbsEnabled={isDeliveryImageThumbsEnabled}
                trackingNumber={trackingNumber}
                recipientZipCode={recipientProfile?.addressDetail?.[0]?.zipCode}
            />
        </>
    );
};

DesktopDeliveryImage.defaultProps = {
    deliveryImageLink: '',
    ROSSOrderDeliveryDate: '',
    ROSSOrderDeliveryTimeFormat: '',
};

DesktopDeliveryImage.propTypes = {
    classes: object.isRequired,
    ROSSOrderDeliveryDate: string,
    ROSSOrderDeliveryTimeFormat: string,
    deliveryImageLink: string,
    track: func.isRequired,
    orderNumber: string.isRequired,
};

export default withStyles(styles)(DesktopDeliveryImage);
